import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingRedirect from "./LandingRedirect";
import RequireAuth from './RequireAuth';
import AdminLogin from './AdminLogin';
import AdminLogout from './AdminLogout';
import Dashboard from './page/Dashboard';
// 
import SpotList from './page/SpotList';
import SpotDetail from './page/SpotList';
import SpotEdit from './page/SpotEdit';
import SpotNew from './page/SpotNew';
// 
import TicketList from './page/TicketList';
import TicketDetail from './page/TicketDetail';
import TicketEdit from './page/TicketEdit';
import TicketNew from './page/TicketNew';
// 
import VoucherList from './page/VoucherList';
import VoucherDetail from './page/VoucherDetail';
import VoucherEdit from './page/VoucherEdit';
import VoucherNew from './page/VoucherNew';
// 
import PackageList from './page/PackageList';
import PackageDetail from './page/PackageDetail';
import PackageEdit from './page/PackageEdit';
import PackageNew from './page/PackageNew';
// 
import CouponList from './page/CouponList';
import CouponDetail from './page/CouponDetail';
import CouponEdit from './page/CouponEdit';
import CouponNew from './page/CouponNew';
// 
import EventList from './page/EventList';
import EventDetail from './page/EventDetail';
import EventEdit from './page/EventEdit';
import EventNew from './page/EventNew';
// 
import SummarySales from './page/SummarySales';
import SummaryUsage from './page/SummaryUsage';
import SummaryTicket from './page/SummaryTicket';
import SummaryPoint from './page/SummaryPoint';
import SummaryPointEdit from './page/SummaryPointEdit';
import SummaryView from './page/SummaryView';
// 
import UserList from './page/UserList';
import UserDetail from './page/UserDetail';
// 
import InformationList from './page/InformationList';
import InformationDetail from './page/InformationDetail';
import InformationEdit from './page/InformationEdit';
import InformationNew from './page/InformationNew';
// 
import NotificationList from './page/NotificationList';
import NotificationDetail from './page/NotificationDetail';
import NotificationEdit from './page/NotificationEdit';
import NotificationNew from './page/NotificationNew';
// 
import SettingTransit from './page/SettingTransit';
import SettingGuide from './page/SettingGuide';
import SettingPoint from './page/SettingPoint';

import StamprallyList from './page/StamprallyList';
import StamprallyDetail from './page/StamprallyDetail';
import StamprallyNew from './page/StamprallyNew';
import StamprallyEdit from './page/StamprallyEdit';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<AdminLogin />} />
        {/* Root */}
        <Route path="/" element={<LandingRedirect />} />
        {/* Protected */}
        <Route element={<RequireAuth />}>
          <Route path="/logout" element={<AdminLogout />} />
          <Route path="/dashboard" element={<Dashboard />} />
          {/* { Spot } */}
          <Route path="/spot" element={<SpotList />} />
          <Route path="/spot/:spotID" element={<SpotDetail />} />
          <Route path="/spot/:spotID/edit" element={<SpotEdit />} />
          <Route path="/spot/new" element={<SpotNew />} />
          {/* { Ticket } */}
          <Route path="/ticket" element={<TicketList />} />
          <Route path="/ticket/:packageId/edit" element={<TicketEdit />} />
          <Route path="/ticket/new" element={<TicketNew />} />
          {/* { Voucher } */}
          <Route path="/voucher" element={<VoucherList />} />
          <Route path="/voucher/:voucherID" element={<VoucherDetail />} />
          <Route path="/voucher/:voucherID/edit" element={<VoucherEdit />} />
          <Route path="/voucher/new" element={<VoucherNew />} />
          {/* { Package } */}
          <Route path="/package" element={<PackageList />} />
          <Route path="/package/:packageID" element={<PackageDetail />} />
          <Route path="/package/:packageID/edit" element={<PackageEdit />} />
          <Route path="/package/new" element={<PackageNew />} />
          {/* { Coupopn } */}
          <Route path="/coupon" element={<CouponList />} />
          <Route path="/coupon/:packageID" element={<CouponDetail />} />
          <Route path="/coupon/:packageID/edit" element={<CouponEdit />} />
          <Route path="/coupon/new" element={<CouponNew />} />
          {/* { Event } */}
          <Route path="/event" element={<EventList />} />
          <Route path="/event/:eventID" element={<EventDetail />} />
          <Route path="/event/:eventID/edit" element={<EventEdit />} />
          <Route path="/event/new" element={<EventNew />} />
          {/* { Stamp } */}
          <Route path="/stamprally" element={<StamprallyList />} />
          <Route path="/stamprally/:stamprallyID" element={<StamprallyDetail />} />
          <Route path="/stamprally/new" element={<StamprallyNew />} />
          <Route path="/stamprally/:stamprallyID/edit" element={<StamprallyEdit />} />
          {/* Summary */}
          <Route path="/summary/sales" element={<SummarySales />} />
          <Route path="/summary/usage" element={<SummaryUsage />} />
          <Route path="/summary/ticket" element={<SummaryTicket />} />
          <Route path="/summary/point" element={<SummaryPoint />} />
          <Route path="/summary/point/:pointActionID/edit" element={<SummaryPointEdit />} />
          <Route path="/summary/view" element={<SummaryView />} />
          {/* { User } */}
          <Route path="/user" element={<UserList />} />
          <Route path="/user/:userID" element={<UserDetail />} />
          {/* { Information } */}
          <Route path="/information" element={<InformationList />} />
          <Route path="/information/:informationID" element={<InformationDetail />} />
          <Route path="/information/:informationID/edit" element={<InformationEdit />} />
          <Route path="/information/new" element={<InformationNew />} />
          {/* { Notification } */}
          <Route path="/notification" element={<NotificationList />} />
          <Route path="/notification/:notificationID" element={<NotificationDetail />} />
          <Route path="/notification/:notificationID/edit" element={<NotificationEdit />} />
          <Route path="/notification/new" element={<NotificationNew />} />
          {/* { Setting } */}
          <Route path="/setting" element={<SettingTransit />} />
          <Route path="/setting/transit" element={<SettingTransit />} />
          <Route path="/setting/guide" element={<SettingGuide />} />
          <Route path="/setting/point" element={<SettingPoint />} />

        </Route>

      </Routes>
    </Router>
  );
}

export default App;
